/* @flow */
import React, { type Node } from 'react';
import DislikesPopUp from '../TinderPopUp/DislikesPopUp';
import ConfirmPopUp from '../TinderPopUp/ConfirmPopUp';

type TProps = {
	apartId: string,
	type: 'dislike' | 'confirm',
	onClose?: () => {},
	noticeList?: any,
	className?: string,
	size?: string,
	withCloseBtn?: boolean,
	hide?: () => {},
	withCloseBtnBottom?: boolean,
};

const PopupSelector = ({
	apartId,
	type,
	onClose,
	noticeList,
	className,
	size,
	withCloseBtn,
	hide,
	withCloseBtnBottom,
}: TProps): Node => {
	switch (type) {
		case 'dislike':
			return (
				<DislikesPopUp
					withCloseBtnBottom={withCloseBtnBottom}
					hide={hide}
					onClose={onClose}
					onEmptyDislikeClick={onClose}
					noticeList={noticeList}
					className={className}
					size={size}
					withCloseBtn={withCloseBtn}
					apartId={apartId}
				/>
			);
		case 'confirm':
			return <ConfirmPopUp message="Вернуть в подбор?" buttonText="Вернуть" onClick={onClose} />;
		default:
			return false;
	}
};

PopupSelector.defaultProps = {
	onClose: () => {},
	noticeList: undefined,
	className: null,
	size: 'm',
	withCloseBtn: false,
	hide: () => {},
	withCloseBtnBottom: false,
};

export default PopupSelector;
